import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { loadHtmlPost, formatDate } from '../utils/markdown';
import Navbar from './core/Navbar';
import Footer from './core/Footer';
import './BlogList.css';

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPosts = async () => {
      try {
        const res = await fetch('/blog/posts/featured_posts.json');
        const postList = await res.json();

        const loadedPosts = await Promise.all(
          postList.map(async (meta) => {
            try {
              const { html } = await loadHtmlPost(meta.file);
              return { ...meta, html };
            } catch (error) {
              console.error(`Error loading post ${meta.file}:`, error);
              return null;
            }
          })
        );

        setPosts(loadedPosts.filter(post => post && post.title));
      } catch (error) {
        console.error('Error loading posts:', error);
      } finally {
        setLoading(false);
      }
    };

    loadPosts();
  }, []);

  return (
    <>
      <Navbar />
      <div 
        className="blog-banner"
        style={{ backgroundImage: 'url(/assets/journey_cropped.png)' }}
      >
        <div className="banner-overlay">
          <div className="banner-content">
            <h1>Numerease Journey</h1>
            <p>Updates, thoughts, and everything Numerease.</p>
          </div>
        </div>
      </div>
      <div className="blog-page">
        <div className="container blog-list">
          {loading ? (
            <div className="loading">Loading posts...</div>
          ) : (
            <div className="posts-grid">
              {posts.length > 0 ? (
                posts.map(post => (
                  <article key={post.file} className="post-card">
                    <Link to={`/blog/${post.file.replace('.html', '')}`}>
                      <h2>{post.title}</h2>
                      <div className="post-meta">
                        {post.author && <span className="author">By {post.author}</span>}
                        {post.date && <span className="date">{formatDate(post.date)}</span>}
                      </div>
                      {post.excerpt && <p className="excerpt">{post.excerpt}</p>}
                    </Link>
                  </article>
                ))
              ) : (
                <p className="no-posts">No posts found.</p>
              )}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}
